import { Card, CardBody } from '@/components/ui';
import type { MilestoneData } from '@/store/milestones/types';
import { NameAvatar } from '@/components/common/output/name';
import { memo } from 'react';
import { MilestoneItem } from '@/components/common/output/milestone';
import { yearsSince } from '@/lib/datetime';
import { DateTime } from 'luxon';
import { StandardIcon } from '@/components/common/icon';

function formatMilestoneDate(date: string, year: boolean): string {
  const d = DateTime.fromFormat(date.substring(0, 10), 'yyyy-MM-dd');
  const s = d.toLocaleString(
    !year ? DateTime.DATE_MED : { month: 'short', day: 'numeric' },
  );

  return s;
}

function MilestoneCard({
  data,
  drawer,
  onPress,
  className,
}: {
  data: MilestoneData;
  drawer?: boolean;
  onPress?: () => void;
  className?: string;
}) {
  const dateLine = formatMilestoneDate(
    drawer ? data.occurred_at : data.next_occurrence,
    !drawer,
  );
  let occurredLine = '';
  if (drawer) {
    const diff = yearsSince(data.occurred_at, new Date());
    occurredLine = diff.display;
  }

  return (
    <Card
      shadow='none'
      className={`cursor-pointer rounded-lg hover:bg-gray-100 ${className}`}
      onPress={onPress}
      isPressable={Boolean(onPress)}
    >
      <CardBody>
        <div className='flex w-full justify-between'>
          <div className='flex items-start gap-4'>
            {!drawer && (
              <NameAvatar value={data.fullname} className='self-start' />
            )}
            <div className='flex flex-col items-start gap-2 text-sm font-medium text-gray-900'>
              <span>{data.fullname}</span>
              <div className={`${drawer ? '' : 'text-sm'} text-default-500`}>
                <MilestoneItem
                  id={data.milestone_id}
                  size={drawer ? 'md' : 'sm'}
                />
              </div>
            </div>
          </div>
          <div className='flex h-full flex-col items-start text-right'>
            <span className='mt-1 flex w-full flex-row justify-end text-sm text-[#92929D]'>
              <StandardIcon id='mdi:event-outline' className='mr-2' />
              <span className='whitespace-nowrap'>{dateLine}</span>
            </span>
            {drawer && (
              <div className='mt-1 flex w-full flex-row justify-end text-xs text-[#92929D]'>
                <span className='whitespace-nowrap'>{occurredLine}</span>
              </div>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default memo(MilestoneCard);
